import megatron from '@stencil/megatron';

import getDeviceId from '@stencil/flights-utils/src/get-device-id';

import { getContext, getSearchContext, getDevice, getUser } from './utils/pdt-logging-utils';

import { IDeviceInfoData } from './types';

const TRANSPORTER_URL = 'https://transporter.makemytrip.com/flights/event-log';

let correlationId: string = '';
let DEVICE_INFO: IDeviceInfoData = {};
let DEFAULT_FLIGHT_SEARCH_DATA = {
  passengers: '',
  flightClass: {
    value: ''
  },
  source: '',
  destination: '',
  departure: '',
  arrival: '',
  journeyType: '',
  travelType: '',
  selectedFareIdentifier: '',
  flavour: ''
};
let DEFAULT_STATIC_INFORMATION = {
  ri: {
    rid: ''
  }
};
// const GEO_INFO: IGeoInfoData = {};

const getDeviceData = flavour => {
  const flavourUP = flavour.toUpperCase();
  return DEVICE_INFO.browser ? DEVICE_INFO : getDevice(flavourUP);
};

const pushPdtLogging = (
  data,
  flightSearchData = DEFAULT_FLIGHT_SEARCH_DATA,
  staticInformation = DEFAULT_STATIC_INFORMATION,
  pageUrl = '',
  exp_experiment_details_list = [],
  correlationIdForLogging = '',
  device_id = '',
  searchContextData = null
) => {
  if (typeof window === 'undefined') {
    return;
  }
  if (!data) {
    return;
  }

  //pass error_message in string
  if (data?.error_message && typeof data.error_message !== 'string') {
    try {
      data['error_message'] = JSON.stringify(data.error_message);
    } catch (ex) {}
  }

  try {
    DEFAULT_FLIGHT_SEARCH_DATA = flightSearchData;
    DEFAULT_STATIC_INFORMATION = staticInformation;
    const {
      passengers,
      flightClass = { value: '' },
      source,
      destination,
      departure,
      arrival,
      journeyType,
      travelType,
      selectedFareIdentifier
    } = flightSearchData;
    const { ri = {} } = staticInformation;
    const { rid } = ri;
    correlationId = rid ? rid : correlationIdForLogging;
    const homeStore = {
      journey_type: journeyType.toUpperCase(),
      fare_type: selectedFareIdentifier,
      passengers,
      travel_class: flightClass.value,
      src: source,
      dest: destination,
      travelType,
      arr: arrival,
      dep: departure
    };
    const deviceInfo = getDeviceData(flightSearchData?.flavour);
    const searchContext = searchContextData ? searchContextData : getSearchContext(homeStore);
    const context = getContext(travelType, correlationId, pageUrl);
    const user = getUser();
    if (!device_id) {
      const urlParams = new URLSearchParams(window?.location?.search);
      device_id = urlParams.get('cval') || getDeviceId() || '';
    }
    window.pdtLayer = window.pdtLayer || [];
    window.pdtLayer.push({
      ...data,
      context,
      exp_experiment_details_list,
      searchContext,
      user,
      device: { ...deviceInfo, device_id }
    });
    if (window.pdtLayer.length === 5) {
      postTransporter();
    }
  } catch (err) {
    console.log('err: ', err);
  }
};

const postTransporter = () => {
  if (window && window.pdtLayer && window.pdtLayer.length) {
    const headers = {
      'Content-Type': 'application/json; charset=UTF-8;',
      'Sub-Type': 'common',
      'Log-Source': 'gi_client',
      'CORRELATION-ID': correlationId,
      'x-pfm': window.flavour || '',
      currency: 'inr',
      locale: 'en-IN'
    };
    const data = { data: window.pdtLayer };
    megatron({
      name: 'pdt transporter api',
      headers,
      type: 'POST',
      url: TRANSPORTER_URL,
      credentials: 'omit',
      requestData: JSON.stringify(data)
    }).then(() => {
      window.pdtLayer = window.pdtLayer.slice(5);
    });
  }
};

let time;
function resetTimer() {
  clearTimeout(time);
  time = setTimeout(postTransporter, 5000);
  // 1000 milliseconds = 1 second
}

if (typeof window !== 'undefined') {
  window.onload = () => {
    resetTimer();
    // getGeolocation();
    DEVICE_INFO = getDeviceData(DEFAULT_FLIGHT_SEARCH_DATA?.flavour);
    // inactivityTime();
  };
  document.ontouchend = resetTimer;
  document.onmousemove = resetTimer;
  document.onkeypress = resetTimer;

  window.addEventListener('beforeunload', function logData() {
    pushPdtLogging({ action_name: 'exit_page' });
    if (window && window.pdtLayer && window.pdtLayer.length) {
      navigator.sendBeacon(
        `/pdt-logging/?data=${JSON.stringify({
          data: window.pdtLayer
        })}&correlationId=${correlationId}`
      );
      window.pdtLayer = [];
    }
  });
}

export default pushPdtLogging;
